import React from 'react'
import "./Verify.css";
import verify1 from '../images/png/Verify1.png';
import verify2 from '../images/png/Verify2.png';
import verify3 from '../images/png/Verify3.png';
import verify4 from '../images/png/Verify4.png';

const Verify=()=> {
  return (
    <>
     <div className='verify'>
        <div className='V'>
            <img src={verify1} alt="error"/>
            <div className='data'>
               <h2>Verified Reviews</h2>
               <p>For verified reviewers</p>   
            </div>
          
        </div>
        <div className='V'>
            <img src={verify2} alt="error"/>
            <div className='data'>
               <h2>Top Articles</h2>
               <p>Helps you decide</p>  
            </div>
             
        </div>
        <div className='V'>
            <img src={verify3} alt="error"/>
            <div className='data'>
               <h2>Write Share Win Contest</h2>
                <p>Earn cash for reviews</p> 
            </div>  
            
        </div>
        
        <div className='V'>
            <img src={verify4} alt="error"/>
            <div className='data'>
                <h2>MouthShut for Brands</h2>
                <p>Request a Demo</p>    
            </div>
            
        </div>
     </div>
     
    </>
  )
}
export {Verify}
